<template>
  <div class="star-rating">
    <Star
      v-for="index in stars"
      :key="index"
      :index="index"
      :hoverRating="hoverRating"
      :rating="rating"
      @setHoverRating="setHoverRating($event, index)"
      @click="setRating(index)"
    >
    </Star>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import Star from "./Star.vue";

interface Props {
  hoverRating: number;
  rating: number;
}

withDefaults(defineProps<Props>(), {});
const emit = defineEmits(["rating", "hover-rating"]);

const stars = ref<number>(5);

function setHoverRating(event: any, index: number) {
  emit("hover-rating", {
    event: event,
    hoverRating: index,
  });
}

function setRating(index: number) {
  emit("rating", {
    rating: index,
  });
}
</script>
<style scoped>
.star-rating {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
